import { connect } from "react-redux";
import ReactSelect from "react-select";

const UpdateDepartment = ({
	departmentOptions,
	updateField,
    data
}) => {
	return (
		<>
			<div className="col-xs-12 form-container">
				<div className="col-xs-6  pl-0">
					<label htmlFor="example2-select2">Department</label>
					<ReactSelect
						options={departmentOptions}
						name="department"
						value={departmentOptions?.find((item) => item.value == data?.department)}
						placeholder="Choose a Department"
						onChange={(selected) => {
							updateField("department", selected?.value || null);
						}}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { departments: departmentList } = state.company?.settings;

	const departmentOptions = departmentList?.map((dep) => ({
		value: dep.id,
		label: dep.name,
	}));

	return {
		departmentOptions,
	};
};
const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDepartment);
